import { RouteFactory } from "@app/routePaths";
import { ConfigObj } from "@typings/Cue";
import { ConfigTypeEnums } from "@typings/enums";

export const isNextSlide = ["Next slide"];
export const isPrevSlide = ["Previous slide"];

export const GE2025_WHATSAPP_SHARE_URL =
  "https://www.whatsapp.com/channel/0029VaI0vLF29753DedKkb24";
export const GE2025_PAGE_QUERY = RouteFactory.keywordsSingaporeGe2025;
export const GE2025_KEYWORD = "ge2025";
export const GE2025_PAGE_SIZE = 10;

export const defaultConfig: ConfigObj[] = [
  {
    type: ConfigTypeEnums.IFRAME,
    src: "https://uat.straitstimes.com/multimedia/graphics/proj-2402-ge-results/bt-widget.html",
    desktop: {
      height: 300,
    },
    mobile: {
      height: 420,
    },
    extraClass: "mb-0",
    gaObject: {
      eventObject: {
        eventCategory: "GE 2025",
        eventLabel: "seats won",
        eventAction: "visible",
        event: "custom_event",
      },
    },
  },
  {
    type: ConfigTypeEnums.IFRAME,
    title: "SAMPLE COUNTS",
    src: "https://public.flourish.studio/visualisation/21458190/",
    extraClass: "border-none",
    gaObject: {
      eventObject: {
        eventCategory: "GE 2025",
        eventLabel: "sample count",
        eventAction: "visible",
        event: "custom_event",
      },
    },
  },
  {
    type: ConfigTypeEnums.TOPSTORIES,
    gaObject: {
      parameters: [
        {
          key: "ref",
          value: "ge2025-top-stories",
        },
      ],
      eventObject: {
        eventCategory: "GE 2025",
        eventLabel: "top stories",
        eventAction: "visible",
        event: "custom_event",
      },
    },
    children: [
      {
        type: ConfigTypeEnums.COMINGUP,
        gaObject: {
          parameters: [
            {
              key: "ref",
              value: "ge2025-coming-up",
            },
          ],
          eventObject: {
            eventCategory: "GE 2025",
            eventLabel: "coming up",
            eventAction: "visible",
            event: "custom_event",
          },
        },
      },
      {
        type: ConfigTypeEnums.VIDEOS,
        gaObject: {
          parameters: [
            {
              key: "ref",
              value: "ge2025-latest-video",
            },
          ],
          eventObject: {
            eventCategory: "GE 2025",
            eventLabel: "latest video",
            eventAction: "visible",
            event: "custom_event",
          },
        },
      },
    ],
  },
  {
    type: ConfigTypeEnums.BANNER,
    title: "SEE ALL THE CANDIDATES",
    src: "https://uat.businesstimes.com.sg/singapore/ge2025-candidates",
    gaObject: {
      parameters: [
        {
          key: "ref",
          value: "ge2025-candidates",
        },
      ],
      eventObject: {
        eventCategory: "GE 2025",
        eventLabel: "Candidates Line Up",
        eventAction: "visible",
        event: "custom_event",
      },
    },
  },
  {
    type: ConfigTypeEnums.CONSTITUENCIES,
    title: "CONSTITUENCIES TO WATCH",
    gaObject: {
      parameters: [
        {
          key: "ref",
          value: "ge2025-candidates",
        },
      ],
      eventObject: {
        eventCategory: "GE 2025",
        eventLabel: "Candidates Line Up",
        eventAction: "visible",
        event: "custom_event",
      },
    },
  },
  {
    type: ConfigTypeEnums.IFRAME,
    title: "ELECTORAL BOUNDARY MAP",
    src: "https://elections.data.gov.sg/en/map?isScrollable=true&primaryColor=%236253E8&view=Boundary%20Change&lang=en&year=2025&constituenciesView=all",
    desktop: {
      height: 650,
    },
    mobile: {
      height: 475,
    },
    gaObject: {
      eventObject: {
        eventCategory: "GE 2025",
        eventLabel: "electoral boundary",
        eventAction: "visible",
        event: "custom_event",
      },
    },
  },
  {
    type: ConfigTypeEnums.CREDITS,
    title: "GRAPHICS: ST, BT, GOVTECH",
  },
  {
    type: ConfigTypeEnums.WHATSAPP,
    onlyMobile: true,
    gaObject: {
      eventObject: {
        eventCategory: "GE 2025",
        eventLabel: "whatsapp",
        eventAction: "visible",
        event: "custom_event",
      },
    },
  },
  {
    type: ConfigTypeEnums.RELATEDSTORIES,
    gaObject: {
      parameters: [
        {
          key: "ref",
          value: "ge2025-latest-news",
        },
      ],
      eventObject: {
        eventCategory: "GE 2025",
        eventLabel: "latest news",
        eventAction: "visible",
        event: "custom_event",
      },
    },
    children: [
      {
        type: ConfigTypeEnums.WHATSAPP,
        onlyDesktop: true,
        gaObject: {
          eventObject: {
            eventCategory: "GE 2025",
            eventLabel: "whatsapp",
            eventAction: "visible",
            event: "custom_event",
          },
        },
      },
      {
        type: ConfigTypeEnums.ADS,
        adType: "imu2",
      },
    ],
  },
];
